const tabConfig = [{
  columnTitle: 'Id',
  dataField: 'ID',
}, {
  columnTitle: 'Banner',
  dataField: 'FILE_NM',
}];

export default tabConfig;
